export default __webpack_public_path__ + "static/media/CrowdfundingFijo.ee893c9d.svg";